var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoucheEgoutFermee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bouche_d_\\xE9gouts",
    "data-name": "bouche d'\\xE9gouts",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 138.86 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afafaf;}.cls-2{fill:#ccc;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_68);}.cls-4{fill:#606060;}.cls-5{fill:#282828;}.cls-6{fill:none;stroke:#3d3d3d;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_68",
    x1: 68.14,
    y1: 3.86,
    x2: 68.14,
    y2: 32.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c1915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f0a09"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bouche d&amp;apos;\xE9gout ferm\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 69.43,
    cy: 20,
    rx: 69.43,
    ry: 18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 69.43,
    cy: 18,
    rx: 69.43,
    ry: 18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 68.14,
    cy: 18,
    rx: 60.43,
    ry: 14.14
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 68.14,
    cy: 18,
    rx: 60.43,
    ry: 14.14
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 69.36,
    cy: 17.78,
    rx: 2.5,
    ry: 0.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 68.14,
    cy: 17,
    rx: 55.72,
    ry: 13.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoucheEgoutFermee);
export default __webpack_public_path__ + "static/media/bouche_egout_fermee.fbf729608fe04d6d78d7312054fb5c82.svg";
export { ForwardRef as ReactComponent };